import { render, staticRenderFns } from "./invoice-purchase-add-or-update.vue?vue&type=template&id=b6d5f6e4&scoped=true"
import script from "./invoice-purchase-add-or-update.vue?vue&type=script&lang=js"
export * from "./invoice-purchase-add-or-update.vue?vue&type=script&lang=js"
import style0 from "./invoice-purchase-add-or-update.vue?vue&type=style&index=0&id=b6d5f6e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6d5f6e4",
  null
  
)

export default component.exports